import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';

import { ReactComponent as Error500Icon } from '../../../../assets/icons/error-pages/error500.svg';
import CommonErrorPage from '../CommonErrorPage/CommonErrorPage';
import ErrorLanguageSelector from '../ErrorLanguageSelector/ErrorLanguageSelector';

const ServiceUnavailableErrorPage = () => {
  const { t } = useTranslation();

  const refreshPage = () => {
    window.location.reload();
  };

  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          top: 16,
          right: 16,
          zIndex: (theme) => theme.zIndex.modal + 1,
        }}>
        <ErrorLanguageSelector />
      </Box>
      <CommonErrorPage
        errorTone="server"
        errorIcon={Error500Icon}
        title={t('serviceUnavailable.title')}
        description={t('serviceUnavailable.description')}
        buttonText={t('serviceUnavailable.refreshButton')}
        onClick={refreshPage}
      />
    </>
  );
};

export default ServiceUnavailableErrorPage;
